import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import Tooltip from 'shared/components/Tooltip';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import RiskLegend from 'components/RiskLegend';
import RiskIcon, { RiskIconLevel } from 'components/RiskIcon';

import './index.scss';

const b = b_.with('risk-info');

interface Props {
  children: RiskIconLevel;
  withIcon?: boolean;
  shapedIcons?: boolean;
  withText?: boolean;
  className?: string;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

class RiskInfo extends React.Component<Enhanced> {
  render() {
    const { t, children: riskLevel, withIcon, shapedIcons, withText, className } = this.props;

    return (
      <Tooltip
        placement="top"
        trigger={['hover']}
        overlay={
          <div className="rc-overlay">
            <RiskLegend shapedIcons={shapedIcons} />
          </div>
        }
      >
        <div className={className}>
          {withIcon && (
            <span className={b('icon')}>
              <RiskIcon shaped={shapedIcons} level={riskLevel} />
            </span>
          )}
          {withText && (
            <span className={b('text', { 'with-indent': withIcon })} data-testid="risk-level">
              {t(riskLevel)} {t('risk')}
            </span>
          )}
        </div>
      </Tooltip>
    );
  }
}

export default enhance(RiskInfo);
